/**
 * Reports a Google Ads conversion event.
 * This function fires a conversion event without redirecting, allowing
 * Next.js Link components to handle navigation.
 *
 * @returns void
 */
export function reportGoogleAdsConversion(): void {
  if (typeof window === 'undefined') return;

  // Check if gtag is available
  if (typeof window.gtag === 'undefined') {
    console.warn('[Google Ads] gtag not found. Conversion event not tracked.');
    return;
  }

  try {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17930769737/X1riCOHIuvUbEMmqh-ZC',
    });

    console.log('[Google Ads] Conversion event fired');
  } catch (error) {
    console.error('[Google Ads] Failed to fire conversion event:', error);
  }
}
